function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.89 5.664H2.11A1.76 1.76 0 00.351 7.422v7.031c0 .97.788 1.758 1.757 1.758h15.782a1.76 1.76 0 001.757-1.758V7.422a1.76 1.76 0 00-1.757-1.758zM4.99 11.85l-.645.002v1.352a.586.586 0 01-1.172 0l-.009-4.451a.586.586 0 01.586-.588h1.24c1.03 0 1.867.827 1.867 1.843s-.838 1.842-1.867 1.842zm5.03 1.799c-.35.006-1.222.009-1.259.01h-.002a.586.586 0 01-.586-.585l-.009-4.322a.586.586 0 01.586-.587h1.224c1.394 0 2.33 1.104 2.33 2.747 0 1.562-.96 2.713-2.284 2.737zm6.004-3.36a.586.586 0 010 1.171h-1.063v1.666a.586.586 0 11-1.172 0v-4.42c0-.324.262-.586.586-.586h1.791a.586.586 0 110 1.172h-1.205v.996h1.063z",
  fill: "#0685FE"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.973 9.336h-.637l.006 3.146c.244-.001.505-.004.657-.006.783-.014 1.133-.796 1.133-1.565 0-.37-.083-1.575-1.159-1.575zM4.99 9.336h-.652a335.178 335.178 0 01.004 1.344l.648-.003c.377 0 .695-.307.695-.67 0-.364-.318-.671-.695-.671zM17.283 4.492a2.924 2.924 0 00-.626-1.01L14.224.913A2.942 2.942 0 0012.097 0h-7.8a1.76 1.76 0 00-1.758 1.758v2.734h14.744zM2.54 17.383v.86c0 .968.788 1.757 1.757 1.757h11.406a1.76 1.76 0 001.758-1.758v-.86H2.539z",
  fill: "#0685FE"
});

function SvgIconPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconPdf;